import axiosInstance from '../axiosInstance.js';

export default function setAuthorizationToken(token) {
    if (token) {
        axiosInstance.defaults.headers.common['authorization'] = `Bearer ${token}`;
    } else {
        axiosInstance.defaults.headers.common['authorization'] = '';
    }
}
